/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Notification } from '../models/Notification';
import { HttpFile } from '../http/http';

export class PaginatedNotificationList {
    'next'?: string;
    'previous'?: string;
    'results'?: Array<Notification>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "next",
            "baseName": "next",
            "type": "string",
            "format": ""
        },
        {
            "name": "previous",
            "baseName": "previous",
            "type": "string",
            "format": ""
        },
        {
            "name": "results",
            "baseName": "results",
            "type": "Array<Notification>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return PaginatedNotificationList.attributeTypeMap;
    }

    public constructor() {
    }
}

